const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveImageUrl(url) {
  if (!url) return url;
  if (url.startsWith("/api/")) {
    return `${BACKEND_URL}${url}`;
  }
  return url;
}
